import css_text from '/srv/www/htdocs/loc/app/styles/web_components/plp.css';

const ICONS = {
	warning: yalwa.basics.static_url('images') + 'yimage/69/1369.svg',
	success: yalwa.basics.static_url('images') + 'yimage/85/1385.svg',
	close: yalwa.basics.static_url('images') + 'yimage/31/1431.svg',
};
class YalwaPlp extends HTMLElement {
	constructor() {
		super();
		this.attachShadow({mode: 'open'});
		this.$dialog = null;
		this.event_namespace = 'plp_ns_' + yalwa.basics.create_uuid(); // unique namespace per instance
		this.apply_css();
	}
	
	async apply_css() {
		await yalwa.basics.check_stylesheet_polyfill_needed();
		const sheet = new CSSStyleSheet();
		sheet.replaceSync(css_text);
		this.shadowRoot.adoptedStyleSheets = [sheet];
		jQuery(this).removeClass('invisible');
	}
	
	static get observedAttributes() {
		return ['open', 'theme', 'hide-close-button', 'no-icon', 'icon-src', 'light-dismiss', 'title-color-var'];
	}
	
	async connectedCallback() {
		import('./button.js');
		import('./link_button.js');
		this.render();
		const ns = '.' + this.event_namespace;
		this.$dialog = jQuery(this.hasAttribute('show-static') ? 'div' : 'dialog', this.shadowRoot);
		
		this.$dialog.find('.js-cancel,.js-close').on('click' + ns, this.on_internal_close);
		this.$dialog.find('.js-confirm').on('click' + ns, this.on_confirm);
		this.$dialog
			.find([
				'slot[name="text_confirm"]',
				'slot[name="confirm_icon_left"]',
				'slot[name="confirm_icon_right"]',
				'slot[name="text_cancel"]',
				'slot[name="cancel_icon_left"]',
				'slot[name="cancel_icon_right"]',
				'slot[name="footer_info"]',
			].join(','))
			.on('slotchange' + ns, this.update_button_visibility);
		this.$dialog.on('close' + ns, this.on_dialog_close);
		this.$dialog.on('click' + ns, this.on_click);
		this.$dialog.on('keydown' + ns, this.on_keydown);
		
		this.update_button_visibility();
		this.update_icon();
		this.apply_title_color();
		if (this.hasAttribute('show-static')) {
			this.show();
		}
	}
	
	disconnectedCallback() {
		if (!this.$dialog) {
			return;
		}
		this.$dialog.off('.' + this.event_namespace);
		jQuery('slot', this.shadowRoot).off('.' + this.event_namespace);
	}
	
	slot_has_content = (slot_name) => {
		const slot = this.$dialog.find(`slot[name="${slot_name}"]`)[0];
		return slot ? slot.assignedNodes().length > 0 : false;
	}
	
	update_button_visibility = () => {
		const hasAny = names => names.some(this.slot_has_content);
		
		const confirmHas = hasAny(['text_confirm','confirm_icon_left','confirm_icon_right']);
		const cancelHas  = hasAny(['text_cancel','cancel_icon_left','cancel_icon_right']);
		const footerHas  = hasAny(['footer_info']); // Track footer separately
		
		this.$dialog.find('[part="button_confirm"]').prop('hidden', !confirmHas);
		this.$dialog.find('[part="button_cancel"]').prop('hidden', !cancelHas);
		
		// Hide the footer wrapper if there's no footer content
		this.$dialog.find('[part="footer_info"]').prop('hidden', !footerHas);
		
		// Keep actions container visible if any of the three exist
		this.$dialog.find('[part="actions"]').prop('hidden', !confirmHas && !cancelHas && !footerHas);
	}
	
	attributeChangedCallback(name, old_value, new_value) {
		if (!this.$dialog) {
			return;
		}
		if (name === 'open' && new_value === null && this.$dialog[0].open) {
			this.close();
		}
		if ((name === 'theme' || name === 'icon-src' || name === 'no-icon') && old_value !== new_value) {
			if (name === 'theme') {
				this.$dialog[0].setAttribute('data-theme', new_value);
			}
			this.update_icon();
		}
		if (name === 'title-color-var' && old_value !== new_value) {
			this.apply_title_color(); // <--- NEW
		}
	}

	// 4) helper that sets the inline color on the title
	apply_title_color = () => {
		const varName = this.getAttribute('title-color-var');
		const titleEl = this.$dialog?.find('[part="title"]')[0] || this.shadowRoot.querySelector('[part="title"]');
		if (!titleEl) return;

		if (varName && varName.trim()) {
			// Accept either "--foo" or "var(--foo)" passed from PHP; normalize to "var(--foo)"
			const match = varName.match(/^var\((--[^)]+)\)$/);
			const normalized = match ? match[1] : varName;
			titleEl.style.color = `var(${normalized})`;
		} else {
			titleEl.style.removeProperty('color');
		}
	};
	
	update_icon = async () => {
		const $container = this.$dialog.find('[part="icon_container"]');
		if (!$container.length) {
			return;
		}
		if (this.hasAttribute('no-icon')) {
			$container.hide();
			return;
		}
		$container.show();
		$container.find('.hero-icon').remove();
		let url = this.getAttribute('icon-src') || ICONS[this.get_theme()];
		if (url) {
			$container.append(`<img loading="lazy" src="${url}" class="hero_icon yimage">`);
		} else {
			$container.hide();
		}
	}
	
	show() {
		if (this.$dialog[0].open) {
			return;
		}
		this.removeAttribute('modal');
		// this.$dialog[0].show();
		yalwa.basics.scroll_lock()
		this.setAttribute('open', '');
	}
	
	show_modal() {
		if (this.$dialog[0].open) {
			this.$dialog[0].close();
		}
		this.setAttribute('modal', '');
		const dialog = this.$dialog[0];
		if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');

		dialog.showModal();
		yalwa.basics.scroll_lock();
		this.setAttribute('open', '');
	}

	
	close() {
		if (!this.$dialog[0].open) {
			return;
		}
		this.$dialog[0].close();
		yalwa.basics.scroll_unlock();
	}
	
	on_internal_close = (event) => {
		this.dispatchEvent(new CustomEvent('plp_cancel', {
			bubbles: true,
			composed: true,
			detail: {original_event: event}
		}));
		this.close();
	}
	
	on_confirm = (event) => {
		const confirm_event = new CustomEvent('plp_confirm', {
			bubbles: true,
			composed: true,
			cancelable: true,
			detail: {original_event: event}
		});
		const should_proceed = this.dispatchEvent(confirm_event);
		if (should_proceed && !this.hasAttribute('no-autohide')) {
			this.close();
		}
	}
	
	on_click = (event) => {
		if (this.hasAttribute('light-dismiss') && event.target === this.$dialog[0]) {
			this.close();
		}
	}
	
	on_dialog_close = (event) => {
		this.removeAttribute('open');
		this.removeAttribute('modal');
		this.dispatchEvent(new CustomEvent('plp_close', {bubbles: true, composed: true}));
	}
	
	on_keydown = (event) => {
		if (event.key === 'Escape' && this.hasAttribute('hide-close-button')) {
			// Prevent the browser's default Esc key behavior for dialogs.
			event.preventDefault();
			event.stopPropagation();
		}
	}
	
	get_theme() {
		return this.getAttribute('theme') || 'info';
	}
	
	render() {
		const theme = this.get_theme();
		const hide_close = this.hasAttribute('hide-close-button') || this.hasAttribute('show-static');
		const confirm_url = this.getAttribute('confirm-url');
		const confirm_tag = confirm_url
			? `<yalwa-link-button full-width href="${confirm_url}" part="button_confirm" class="js-confirm">`
			: `<yalwa-button full-width part="button_confirm" class="js-confirm">`;
		const confirm_tag_close = confirm_url ? `</yalwa-link-button>` : `</yalwa-button>`;
		let tagname = this.hasAttribute('show-static') ? 'div' : 'dialog';
		this.shadowRoot.innerHTML = `
<${tagname} part="dialog" data-theme="${theme}">
${!hide_close ? `
	<button part="button_close" class="js-close">
		<img loading="lazy" src="${ICONS.close}" class="yimage" width="28" height="28">
	</button>
` : ''}
	<div part="icon_container">
		<slot name="icon"></slot>
	</div>
	<div part="title" class="title">
		<slot name="title"></slot>
	</div>
	<div part="content" class="content">
		<slot></slot>
	</div>
	<div part="actions" class="actions">
		${confirm_tag}
		<!-- Bridge PLP slots into the child button's slots -->
		<slot name="confirm_icon_left"  slot="icon_left"></slot>
		<slot name="text_confirm"></slot> <!-- default slot (label) -->
		<slot name="confirm_icon_right" slot="icon_right"></slot>
		${confirm_tag_close}
		<yalwa-button intent="secondary" variant="subtle" full-width part="button_cancel" class="js-cancel">
		<slot name="cancel_icon_left"  slot="icon_left"></slot>
		<slot name="text_cancel"></slot> <!-- default slot (label) -->
		<slot name="cancel_icon_right" slot="icon_right"></slot>
		</yalwa-button>
		
		<div part="footer_info" class="footer-info">
           <slot name="footer_info"></slot>
       </div>
	</div>
</${tagname}>
		`;
	}
}

customElements.define('yalwa-plp', YalwaPlp);

jQuery('.js-plp_show_immediately').each(function() {
	this.show_modal();
});

